
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import { isOnFreePlan } from '@/ui/auth/auth';
  import { Button } from '@/ui/components/Button';
  import MultiStepConfigurationModal from './multiStepModal/MultiStepConfigurationModal.vue';
  import SingleStepConfigurationModal from './SingleStepConfigurationModal.vue';
  import { computed, defineComponent, ref } from 'vue';

  export default defineComponent({
    components: {
      MultiStepConfigurationModal,
      SingleStepConfigurationModal,
      Button,
    },
    setup() {
      const store = useIntegrationDetailsStore();
      const { isSingleStep } = store;
      const loading = ref(false);

      const openModal = () => {
        if (isSingleStep) {
          store.openModal();
          return;
        }

        loading.value = true;
        store.openMultiStepModal().then(() => {
          loading.value = false;
        });
      };

      const isDisabled = computed(() => isOnFreePlan.value || !store.integration?.enabled);

      return {
        isDisabled,
        isSingleStep,
        openModal,
        loading,
      };
    },
  });
